import getcruxGlassLogo from "@/assets/getcruxglasslogo.svg";

export default function GlobalLoader({
  showProgressBar = true,
}: {
  showProgressBar?: boolean;
}) {
  return (
    <div className="w-full h-[90vh] flex flex-col items-center justify-center gap-8 m-auto">
      <img src={getcruxGlassLogo} className=" w-[56px] h-[56px]" alt="" />
      <div
        className={`relative bg-[#CDCDCD66] h-[3px] rounded-full w-[360px] ${
          showProgressBar ? "visible" : "invisible"
        }`}
      >
        <div
          className="h-[3px] rounded-full w-[0%] animate-progress"
          style={{
            background: "linear-gradient(90deg, #FCAB8C 36.54%, #FF85B6 58.65%)",
          }}
        ></div>
      </div>
    </div>
  );
}
